import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { type IconDefinition, type IconName } from '@fortawesome/fontawesome-common-types';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { NavigationService } from '@reconcept-platform/shared/navigation/nav-content';
import { ListItemComponent } from '@reconcept-platform/shared/ui/standalone/list';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';
import { NavListContainerComponent } from '../nav-list-container/nav-list-container.component';

@Component({
  selector: 'rcp-nav-list-item',
  template: `
    <div
      [rcpPopover]="tooltipText()"
      [rcpPopoverIsEnabled]="collapsed()"
      rcpPopoverPlacement="right"
      [class.expanded]="!collapsed()"
      class="item-container"
    >
      <rcp-list-item [icon]="itemIcon()" [label]="labelText()" [active]="active()" [disabled]="disabled()">
        <ng-container leading-detail>
          <ng-content select="[custom-icon]" />
        </ng-container>

        <ng-content />

        <ng-container trailing-detail>
          <ng-content select="[trailing-detail]" />
        </ng-container>
      </rcp-list-item>
    </div>
  `,
  styleUrl: './nav-list-item.component.scss',
  imports: [ListItemComponent, RcpPopoverDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NavListItemComponent {
  private navigation = inject(NavigationService);
  private navListContainer = inject(NavListContainerComponent, { host: true });

  active = input<boolean>(false);
  disabled = input<boolean>(false);
  label = input<string>();
  iconTyped = input<IconDefinition>();
  icon = input<IconName | undefined>(undefined);
  iconSolid = input<boolean>(false);
  align = input<'left' | 'right'>('left');
  popoverText = input<string>();

  expanded = input<boolean>();
  collapsable = computed<boolean>(() => this.navListContainer.collapsable());
  collapsed = computed(() => (this.collapsable() ? this.navigation.sidebarIsCollapsed() : false));
  // @ts-expect-error TS2322 type not assignable
  labelText = computed<string>(() => (this.collapsable() && this.collapsed() ? '' : this.label()));
  // @ts-expect-error TS2322 type not assignable
  tooltipText = computed<string>(() => (this.popoverText() ? this.popoverText() : this.label()));
  // @ts-expect-error TS2345 argument not assignable
  itemIcon = computed<IconProp>(() => this.getIcon(this.iconTyped(), this.iconSolid(), this.icon()));

  private getIcon(iconTyped: IconDefinition, iconSolid: boolean, icon: IconName): IconProp {
    if (iconTyped) {
      return iconTyped;
    } else if (icon) {
      return [iconSolid ? 'fas' : 'far', icon];
    } else {
      // @ts-expect-error TS2322 type not assignable
      return undefined;
    }
  }
}
